import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'

Vue.use(Vuex)

const vueDataEl = document.getElementById('vue-data')
const vueData = vueDataEl ? JSON.parse(vueDataEl.text) : {}

export default new Vuex.Store({
  state: {
    agent: vueData.agent,
    docs: vueData.files,
    regions: vueData.regions || [],
    regionBranches: vueData.regionBranches || {},
    agreementEnumFields: {},
    agreements: [],
    applications: [],
    applicationStages: [],
    operations: [],
    cities: [],
  },
  getters: {},
  mutations: {
    setAgreements(state, { agreements }) {
      state.agreements = agreements
    },
    setAgreementEnumFields(state, { enumFields }) {
      state.agreementEnumFields = enumFields
    },
    setApplications(state, { applications }) {
      state.applications = applications
    },
    setApplicationStages(state, { stages }) {
      state.applicationStages = stages
    },
    setOperations(state, { operations }) {
      state.operations = operations
    },
    setCities(state, { cities }) {
      state.cities = cities
    },
    updateAgent(state, payload) {
      state.agent = {
        ...state.agent,
        ...payload,
      }
    },
    // Функции для оптимистичного обновления суммы к получению/доступной для выплаты
    optimisticWithdraw(state, amount) {
      const [toWithdraw, ...restWithdraw] = state.agent.rewardToWithdraw.split('|')
      const [blocked, ...restBlocked] = state.agent.rewardBlocked.split('|')

      const newToWithdraw = Number(toWithdraw) - Number(amount)
      const newBlocked = Number(blocked) + Number(amount)

      state.agent.rewardToWithdraw = [newToWithdraw, ...restWithdraw].join('|')
      state.agent.rewardBlocked = [newBlocked, ...restBlocked].join('|')
    },
    rollbackWithdraw(state, prev) {
      state.agent.rewardToWithdraw = prev.rewardToWithdraw
      state.agent.rewardBlocked = prev.rewardBlocked
    }
  },
  actions: {
    async getAgreements({ commit }) {
      const { data: { agreements, enumFields } } = await axios.get('/api/get_agreements/')
      commit('setAgreements', { agreements })
      commit('setAgreementEnumFields', { enumFields })
    },
    async getApplications({ commit }) {
      const { data: { agreements, applications, stages } } = await axios.get('/api/get_applications/')
      commit('setAgreements', { agreements })
      commit('setApplications', { applications })
      commit('setApplicationStages', { stages })
    },
    async getOperations({ commit }) {
      const { data: { operations } } = await axios.get('/api/get_operations/')
      commit('setOperations', { operations })
    },
    async getCities({ commit }) {
      const { data: { cities } } = await axios.get('/api/get_cities/')
      commit('setCities', { cities })
    },
  },
})
